<template>
  <table class="data-table">
    <thead class="data-table__head">
      <tr>
        <th class="v_text_default--text">{{ $t('statistic.collectedDataTable.headers.type') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.collectedDataTable.headers.name') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.collectedDataTable.headers.description') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.collectedDataTable.headers.id') }}</th>
        <th class="v_text_default--text">{{ $t('statistic.collectedDataTable.headers.totalScans') }}</th>
      </tr>
    </thead>

    <tbody class="data-table__body v_bg_default">
      <tr v-for="(item, index) in data"
          :key="`dt-${item._id}-${index}`">
        <td class="v_text_default--text">{{ types[item.type] }}</td>
        <td class="v_text_default--text">{{ item.title }}</td>
        <td class="v_text_default--text">{{ item.subtitle }}</td>
        <td class="v_text_default--text">{{ item._id }}</td>
        <td class="v_text_default--text">{{ item.count }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["items"],
  computed: {
    data() {
      return this.items.sort((a, b) => {
        return a.title > b.title ? 1 : -1;
      });
    },
  },
  data: () => ({
    types: {
      badge: "Бейдж",
      product: "Продукт",
      company: "Компания",
    },
  }),
};
</script>

<style lang="scss" scoped>
.data-table {
  width: 100%;
  font-size: 14px;
}

.data-table td {
  padding: 0 20px;
}



.data-table tr {
  height: 64px;
  border-bottom: 1px solid rgba(230, 228, 234, 0.64);

  &:last-child td {
    &:first-child {
      border-radius: 0 0 0 10px;
    }

    &:last-child {
      border-radius: 0 0 10px 0;
    }
  }
}

.data-table th {
  background-color:var(--v-v_sub_bg-base)!important;
  padding: 0 20px;

  &:first-child {
    padding-right: 0;
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 0 10px 0 0;
  }
}

.data-table__body {
  background: #f3f2f7;
}
.standman-color {
  height: 15px;
  width: 15px;
  border-radius: 50%;
}
.first-column {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
